

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import vSelect from "vue-select"
import { Team } from "@/types"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class FieldPermissions extends Vue {
	@Prop()
	public value: any;

	@Prop()
	public fieldPermissions: any;

	@Prop()
	public edit!: boolean;

	@Prop()
	public disabled!: boolean;

	@setup.Getter("getTeams")
	teams!: Team[];

	recordEdit: boolean = true;

	@Watch("value")
	public valudChanged (newValue: any) {
		if (this.fieldPermissions) {

		} else {
			if (!newValue.view) {
				newValue.view = []
			}
			if (!newValue.edit) {
				newValue.edit = []
			}
		}
	}

	public viewSelectionChanged (newValue: any) {
		this.$emit("input", {
			view: newValue,
			edit: this.value.edit
		})
	}
	public editSelectionChanged (newValue: any) {
		this.$emit("input", {
			view: this.value.view,
			edit: newValue
		})
	}

	public displayTeams (teams: Team[]): string {
		if (teams.length === 0) {
			return "Any"
		}

		return teams.map(t => t.title).join(", ")
	}

	private overrideDefaults () {
		this.$emit("input", {
			view: this.fieldPermissions.view,
			edit: this.fieldPermissions.edit
		})
	}
}

